import assignToThis from '../../../helper/assignToThis';

export class ScenarioRenFrPV {
  
  public unit_power: number | null = null;
  public module_area: number | null = null;
  public p50_annual_degradation: number | null = null;
  public p90_annual_degradation: number | null = null;
  public installed_capacity: number | null = null;
  public dc_ac_ratio: number | null = null;

  public net_p50: number | null = null;
  public net_p90: number | null = null;

  public numberOfPdl: number | null = null;
  public numberOfPdlPtr: number | null = null;
  public numberOfPtr: number | null = null;

  public constructor(obj: object = {}) {
    assignToThis(this, obj);

  }

}
